import React from 'react';
import withIcon from '../utilities/withIcon'; 

const IconChartVertStacked = () => {
  return (

      <g>
        <path
          d="m6.05.004.11.006a.95.95 0 0 1 .834.833L7 .953v3.051h2.55l.11.006a.95.95 0 0 1 .834.833l.006.11v2.051h2.55l.11.006a.95.95 0 0 1 .834.833l.006.11-.001 2.547.005 1.5-.006 2.497h1.252a.75.75 0 0 1 .102 1.492l-.102.007-1.253.001V16h-12v-.003H.75a.75.75 0 0 1-.102-1.494l.102-.007 1.247.001L2 .954l.006-.111A.95.95 0 0 1 2.84.01L2.95.004h3.1zM5.499 8h-2l-.002 6.497h2L5.499 8zm3.499 2h-2l-.001 4.497h2L8.998 10zm3.5 2h-2l-.001 2.497h2L12.498 12zm.002-3.496h-2l-.001 1.996h2l.001-1.996zm-3.5-3H7V6.5L7.004 8l-.005.5h2L9 5.504zm-3.5-4h-2L3.499 6.5h2L5.5 1.504z"
          
        />
      </g>
  );
};


export default withIcon(IconChartVertStacked);
